import { CompanyProfileDetailCreateOrEditDto, CountryMasterDto, CreateOrEditCaptureSettingDto, DropdownProjectListDto, MyProfileOutput, UserTrackOtherSettingCreateOrEditDto, UserTrackingSettingCreateOrEditDto } from "./service-proxies/service-proxies";

export class AppConsts {
    static readonly tenancyNamePlaceHolderInUrl = "{TENANCY_NAME}";

    static remoteServiceBaseUrl: string;
    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish
    static appBaseUrlFormat: string;
    static recaptchaSiteKey: string;
    static azureMapsSubscriptionKey: string;
    static subscriptionExpireNootifyDayCount: number;
    static myProfileInfo: MyProfileOutput;
    static isCheckClient: any;
    static localeMappings: any = [];
    static initialLoadAppComponent = false;
    static initialLoadHeaderNotificationComponent = false;
    static initialLoadSideBar = false;
    static getCaptureSettingForEditViewInstance: CreateOrEditCaptureSettingDto;
    static getUserTrackingSettingForEditInstance: UserTrackingSettingCreateOrEditDto;
    static unreadNotificationCount: number;
    static readonly userManagement = {
        defaultAdminUserName: "admin",
    };

    static readonly sectionNameForUserDisplay = {
        archive: "archiveUsers",
        delete: "deleteUser",
        allUsers: "allUsers",
    };

    static readonly sectionNameForUserDisplayProject = {
        allProject: "All Projects",
        archiveProject: "Archived Projects",
        deleteProject: "Deleted Projects",
    };

    static readonly localization = {
        defaultLocalizationSourceName: "INTIME",
    };

    static readonly authorization = {
        encrptedAuthTokenName: "enc_auth_token",
    };

    /** Survives app session timeout so Microsoft SSO can sign in silently (no MFA). Cleared on explicit logout. */
    static readonly microsoftSso = {
        resumeAfterTimeoutKey: "ITP.MicrosoftSso.ResumeAfterTimeout",
        loginHintKey: "ITP.MicrosoftSso.LoginHint",
    };

    static readonly grid = {
        defaultPageSize: 10,
    };

    static readonly MinimumUpgradePaymentAmount = 1;

    /// <summary>
    /// Gets current version of the application.
    /// It's also shown in the web page.
    /// </summary>
    static readonly WebAppGuiVersion = '12.1.0';

    /// <summary>
    /// Redirects users to host URL when using subdomain as tenancy name for not existing tenants
    /// </summary>
    static readonly PreventNotExistingTenantSubdomains = false;

    static dateFormatId: number;
    static companyDetails: CompanyProfileDetailCreateOrEditDto;

    static userSettings: UserTrackOtherSettingCreateOrEditDto;

    static readonly dateFormatList = [
        { id: 1, name: "DD/MM/YYYY" },
        { id: 2, name: "MM/DD/YYYY" },
        { id: 3, name: "YYYY/DD/MM" },
    ];
    static loggedInUserImage: string;

    // Timesheet approver
    static isCurrentUserTimesheetApprover: boolean;
    static userRoleArray: string[];

    static BackgroundImagephoto =  "https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/webIcons/webImgw4cj1l3i.w5s.png";
    static reportProjectDropdownList: DropdownProjectListDto[];
    static allCountry: CountryMasterDto[];
}
